import { useDispatch, useSelector } from "react-redux"

import { healthSetProp } from "../../../../redux/health.slice"
import { createVampEnrollment } from "../../../../redux/health.thunks"

export const useEnrollmentModal = () => {
  const dispatch = useDispatch()
  const vampEnrollmentRequestLoading = useSelector(
    (state) => state.health.vampEnrollmentRequestLoading
  )

  const open = () => {
    dispatch(healthSetProp({ key: "showEnrollmentModal", value: true }))
  }

  const close = () => {
    dispatch(healthSetProp({ key: "showEnrollmentModal", value: false }))
  }

  const isOpened = useSelector((state) => state.health.showEnrollmentModal)

  const enroll = async (data) => {
    if (vampEnrollmentRequestLoading) return
    // Resolves with the created enrollment, rejects with `{ message }` - same contract the
    // `onSuccess`/`onError` payload callbacks had before the thunk migration.
    const { enrollmentData } = await dispatch(createVampEnrollment(data)).unwrap()
    return enrollmentData
  }

  return {
    open,
    close,
    enroll,
    isOpened,
    loading: vampEnrollmentRequestLoading
  }
}
